import { Component } from 'react';
import * as _ from 'lodash';
import { IDonorConnectIncidentLog, IListItem } from '@nkr/models/index';
import { Button, Glyphicon, Label, Well } from 'react-bootstrap';
import LogEntry from './log-entry';
import DeleteLogEntryConfirmation from './delete-log-entry-confirmation';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    incidentReportId: number,
    logs: IDonorConnectIncidentLog[],
    statusList: IListItem[],
    actionList: IListItem[],
    container: any,
    isMobile: boolean,
    onSaveLogEntry: (id: number, incidentReportId: number, actionTaken: number, comments: string) => void,
    onDeleteLogEntry: (id: number, incidentReportId: number) => void
}

interface IState {
    addEdit: {
        show: boolean,
        data: IDonorConnectIncidentLog
    },
    delete: {
        show: boolean,
        data: IDonorConnectIncidentLog
    }
}

class Log extends Component<IProps, IState> {
    readonly state: IState = {
        addEdit: {
            show: false,
            data: null
        },
        delete: {
            show: false,
            data: null
        }
    }

    handleShowAddEdit = (data: IDonorConnectIncidentLog) => {
        this.setState({
            addEdit: {
                show: true,
                data
            }
        });
    }

    handleCancelAdd = () => {
        this.setState({
            addEdit: {
                show: false,
                data: null
            }
        });
    }

    handleSaveLogEntry = (actionTaken: number, comments: string) => {
        let id = this.state.addEdit.data != null ? this.state.addEdit.data.id : 0;

        this.props.onSaveLogEntry(id, this.props.incidentReportId, actionTaken, comments);

        this.setState({
            addEdit: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmDeleteLogEntry = (data: IDonorConnectIncidentLog) => {
        this.setState({
            delete: {
                show: true,
                data
            }
        });
    }

    handleCancelDeleteLogEntry = () => {
        this.setState({
            delete: {
                show: false,
                data: null
            }
        });
    }

    handleDeleteLogEntry = () => {
        let id = this.state.delete.data.id;

        this.props.onDeleteLogEntry(id, this.props.incidentReportId);

        this.setState({
            delete: {
                show: false,
                data: null
            }
        });
    }

    render = () => {
        const logList = _.orderBy(this.props.logs, item => {
            if (item.updateDateTime != '') {
                return new Date(item.updateDateTime);
            } else {
                return new Date(item.logDateTime);
            }
        }, ['desc']);

        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, marginBottom: 5 }}>
                    <h3 style={{ margin: 0 }}>Logs</h3>
                    <Button bsStyle='link' onClick={() => this.handleShowAddEdit(null)}>Add Log Entry</Button>
                </div>

                {this.state.addEdit.show && (
                    <LogEntry
                        data={this.state.addEdit.data}
                        actionList={this.props.actionList}
                        onSave={this.handleSaveLogEntry}
                        onCancel={this.handleCancelAdd}
                    />
                )}

                <div style={{ height: this.props.isMobile == false ? '48vh' : 300, overflowY: 'scroll', border: this.props.isMobile == false ? '1px solid lightblue' : null, borderRadius: 4, padding: 5 }}>
                    {logList.map(log =>
                        <Well key={'log-' + log.id} style={{ padding: 7, marginBottom: 5, }} >
                            <div style={{ marginBottom: 15, display: 'flex', justifyContent: 'space-between'}}>
                                <div>
                                    {log.updateDateTimeForDisplay != '' && (
                                        <div><Label bsStyle='info' style={{ color: 'black' }}>Updated {log.updateDateTimeForDisplay} By {log.updatedByFullName}</Label></div>
                                    )}
                                    <div><Label bsStyle='primary'>Created {log.logDateTimeForDisplay} By {log.createdByFullName}</Label></div>
                                </div>
                                {log.isEditable == false && log.isDeletable == false && (
                                    <Glyphicon glyph='lock' style={{ color: 'darkred' }} title="This is a system generated log entry and can't be edited nor deleted" />
                                )}
                            </div>

                            {(log.isEditable || log.isDeletable) && (
                                <h4 style={{ marginBottom: 10 }}>
                                    <Label >{log.actionTaken}</Label>
                                </h4>
                            )}

                            <div style={{ backgroundColor: 'white', border: '1px solid #ddd', borderRadius: 4, padding: 5, marginBottom: 5, overflowY: 'scroll' }}>{ReactHtmlParser(log.comments.replace(/<|>/g, '').replace(/(?:\r\n|\r|\n)/g,'<br/>'))}</div>

                            <div className='text-right'>
                                {log.isEditable && (
                                    <Button bsSize='sm' style={{ marginRight: 5 }} title='Edit this log entry...' onClick={() => this.handleShowAddEdit(log)}>
                                        <Glyphicon glyph='edit' />
                                    </Button>
                                )}

                                {log.isDeletable && (
                                    <Button bsSize='sm' title='Delete this log entry...' onClick={() => this.handleConfirmDeleteLogEntry(log)}>
                                        <Glyphicon glyph='trash' />
                                    </Button>
                                )}
                            </div>
                        </Well>
                    )}

                    {logList.length == 0 && (
                        <Well>
                            No log entries have been added yet....
                        </Well>
                    )}
                </div>

                <DeleteLogEntryConfirmation
                    show={this.state.delete.show}
                    data={this.state.delete.data}
                    container={this.props.container}
                    onDelete={this.handleDeleteLogEntry}
                    onCancel={this.handleCancelDeleteLogEntry}
                />
            </>
        );
    }
}

export default Log;